import React, {Component, useState, useEffect, useRef} from "react";
import {Link} from "react-router-dom";
import logo800 from "../assets/images/logo800.png";
import mazaronline from "../assets/images/mazar-online.jpg";
import mohsenin from "../assets/images/mohsenin.jpg";
import khatm from "../assets/images/khatm.jpg";
import baghi from "../assets/images/baghi.jpg";
import Goorbagheh from "../assets/images/Goorbagheh.png";
import gallery1 from "../assets/images/gallery1.jpg";
import gallery2 from "../assets/images/gallery2.jpg";
import gallery3 from "../assets/images/gallery3.jpg";
import gallery4 from "../assets/images/gallery4.jpg";
import gallery5 from "../assets/images/gallery5.jpg";
import gallery6 from "../assets/images/gallery6.jpg";
import gallery7 from "../assets/images/gallery7.jpg";
import gallery8 from "../assets/images/gallery8.jpg";

import {notifySuccessfulMessageLong} from "../App";

import "../App.css";
import {useIsLogin} from "../hooks";
import Footer from "./Footer";
import TopNav from "./TopNav";
import sia, {IMG_DIR} from "../services/Api";
import LoaderView from "../tools/LoaderView";

const Home = (props) => {
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [lastDead, setLastDead] = useState();
    const [highlightedDead, setHighlightedDead] = useState();
    const [isLoading, setLoading] = useState(true);
    const [isLoadingCities, setLoadingCities] = useState(true);
    const [optionData, setOptionData] = useState([]);


    const selectedStateIndex = useRef()
    const selectedCityIndex = useRef()
    const deadCode = useRef('')
    const deadName = useRef('')

    const isLogin = useIsLogin();

    useEffect(() => {
        let url = window.location.href;
        url = url.split('?');
        if (url.length == 2) {
            notifySuccessfulMessageLong('\n' +
                'مبلغ ' + url[1] + ' تومان اهدا شد\n' +
                'نکویاد با هدف خلق اثری ماندگار در زمینه کسب و کارهای آنلاین در خصوص برگزاری مجالس ختم آنلاین، ختم دوره و صلوات و نیز دیدبانی هوشمند جهت حمایت از نیازمندان و محرومین می باشد. از آن جهت که کلیه خدمات در این بستر رایگان می باشد در صورت صلاحدید می توانید این سامانه را در راستای ارتقای کیفیت همراهی نموده و از ما حمایت نمایید. پیشاپیش از شما کمال تشکر و قدردانی را داریم .')
        }
        if (url.length == 3) {
            notifySuccessfulMessageLong('\n' +
                'مبلغ ' + url[1] + ' تومان اهدا شد\n' +
                'خیر ارجمند از حسن توجه جنابعالی به سامانه و مرکز خیریه نکویاد کمال تشکر و قدردانی را داریم.تقاضا می گردد پس از ادای نذر و یا پرداخت هزینه حتما ما را مطلع فرمایید . از همراهی شما بی نهایت سپاسگزاریم.\n' +
                '05138558474\n' +
                '09150974945')
        }

        getStates();
        getOptions();
    }, []);

    const getStates = async () => {
        setLoading(true)
        await sia
            .getDataFromServer("state")
            .then((res) => {
                setStates(res.data);
                getLastDead()
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const getOptions = async () => {
        await sia
            .getDataFromServer("about")
            .then((res) => {
                setOptionData(res.data.data);
                console.log(res.data.data)
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const getCities = async () => {
        setCities([])
        setLoadingCities(true)
        await sia
            .getDataFromServer("city?state_id=" + states[selectedStateIndex.current].id)
            .then((res) => {
                setCities(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
        setLoadingCities(false)
    }

    const getLastDead = async () => {
        setLoading(true)
        await sia
            .getDataFromServer("dead?latest=1")
            .then((res) => {
                setLastDead(res.data.last);
                setHighlightedDead(res.data.highlighted);
            })
            .catch((err) => {
                console.log(err);
            });
        setLoading(false)
    }

    return (
        <>
            {isLoading ? <LoaderView/> : <div>
                <header>
                    <div className="pagewrapper" id="header-home">
                        <div className="container">
                            <TopNav/>
                            <div className="content">
                                <Link to="#" title="">
                                    <img
                                        src={logo800}
                                        alt=""
                                        className="logo"
                                        width="331"
                                        height="284"
                                    />
                                </Link>
                                <div className="filters-wrapper">
                                    <div id="home-header-filters">
                                        <select name="state" onChange={(e) => {
                                            selectedStateIndex.current = e.target.value
                                            getCities()
                                        }} className="box-sizing">
                                            <option value="-1">استان</option>
                                            {states.map((item, index) => <option value={index}>{item.name}</option>)}
                                        </select>
                                        <select name="city" className="box-sizing" onChange={(e) => {
                                            selectedCityIndex.current = e.target.value
                                        }}>
                                            <option value="-1">شهر</option>
                                            {!isLoadingCities && cities.map((item, index) => <option
                                                value={index}>{item.name}</option>)}
                                        </select>
                                        <input
                                            type="text"
                                            name="code"
                                            placeholder="کد متوفی"
                                            className="box-sizing"
                                            onChange={(e) => deadCode.current = e.target.value}
                                        />
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="نام"
                                            className="box-sizing"
                                            onChange={(e) => deadName.current = e.target.value}
                                        />
                                        <input type="submit" onClick={() => {
                                            const dName = deadName.current.length > 0 ? ('&d-name=' + deadName.current) : ''
                                            const dCode = deadCode.current.length > 0 ? ('&d-code=' + deadCode.current) : ''
                                            const city = cities.length > 0 ? cities[selectedCityIndex.current].id : ''
                                            window.location = './d-list?city=' + city + dName + dCode
                                        }
                                        } value="جستجو"/>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="top-section-bullets">
                <Link to="" title="" className="item ease box-sizing"></Link>
                <Link
                  to=""
                  title=""
                  className="item selected ease box-sizing"
                ></Link>
                <Link to="" title="" className="item ease box-sizing"></Link>
                <Link to="" title="" className="item ease box-sizing"></Link>
              </div> */}

                            <div className="clear"></div>
                        </div>
                    </div>
                </header>
                <div className="clear"></div>

                <div className="pagewrapper" id="statistics">
                    <div className="container col-3">
                        <div className="right-col">
                            <div className="stat-item box-sizing">
                                <span>{optionData.options.about_us_help_amount1}</span>
                                کل مبلغ اهدایی
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{optionData.options.about_us_help_amount2}</span>
                                مبلغ اهدایی هفتگی
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{optionData.salavatCount}</span>
                                صلوات ها
                            </div>
                        </div>
                        <div className="pinbar"></div>
                        <div className="left-col">
                            <div className="stat-item box-sizing">
                                <span>{optionData.fateheCount}</span>
                                فاتحه ها
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{optionData.options.today_count1}</span>
                                کل ثبت ها
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{optionData.options.today_count2}</span>
                                ثبت هفتگی
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pagewrapper" id="motevafa">
                    <div className="container">
                        {lastDead && <div className="motevafa-item box-sizing">
                            <img
                                src={IMG_DIR + lastDead.picture}
                                alt=""
                                width=""
                                height=""
                                className="motevafa-thumb"
                            />
                            <a className="link-btn ease box-sizing radius50 mouse-cursor-pointer"
                               onClick={() => window.location.assign('/motevafa/' + lastDead._id)}>
                                <h3 className="motevafa-title box-sizing">
                                    شادروان {lastDead.name}
                                </h3>
                            </a>
                            <div className="motevafa-date">
                                <span>ولادت : {lastDead.birthday}</span>
                                <span>وفات : {lastDead.deathDate}</span>
                            </div>
                            <p className="motevafa-text box-sizing">
                                {lastDead.disc}
                            </p>
                            <Link to={"./motevafa/" + lastDead._id} title="مشاهده همه"
                                  className="motevafa-more radius15">
                                ورود به صفحه
                            </Link>
                        </div>}
                    </div>
                </div>

                {highlightedDead && <div className="pagewrapper" id="motevafa">
                    <div className="container">
                        {lastDead && <div className="motevafa-item box-sizing">
                            <img
                                src={IMG_DIR + highlightedDead.picture}
                                alt=""
                                width=""
                                height=""
                                className="motevafa-thumb"
                            />
                            <a className="link-btn ease box-sizing radius50 mouse-cursor-pointer"
                               onClick={() => window.location.assign('/motevafa/' + highlightedDead._id)}>
                                <h3 className="motevafa-title box-sizing">
                                    شادروان {highlightedDead.name}
                                </h3>
                            </a>
                            <div className="motevafa-date">
                                <span>ولادت : {highlightedDead.birthday}</span>
                                <span>وفات : {highlightedDead.deathDate}</span>
                            </div>
                            <p className="motevafa-text box-sizing">
                                {highlightedDead.disc}
                            </p>
                            <Link to={"./motevafa/" + highlightedDead._id} title="مشاهده همه"
                                  className="motevafa-more radius15">
                                ورود به صفحه
                            </Link>
                        </div>}
                    </div>
                </div>}

                <div className="pagewrapper" id="home-category-banner">
                    <div className="container">
                        <Link to="./profile-first" title="">
                            <img
                                src={mazaronline}
                                alt=""
                                width="1376"
                                height="215"
                                className="ease"
                            />
                        </Link>
                        <Link to="./mohsenin" title="">
                            <img
                                src={mohsenin}
                                alt=""
                                width="1376"
                                height="215"
                                className="ease"
                            />
                        </Link>
                        <Link to={isLogin ? "./khatm-archive" : "./login"} title="">
                            <img
                                src={khatm}
                                alt=""
                                width="1376"
                                height="215"
                                className="ease"
                            />
                        </Link>
                    </div>
                </div>

                <div className="pagewrapper" id="home-about">
                    <div className="container">
                        <Link to="" title="">
                            <img src={baghi} alt="" width="572" height="572" className="ease"/>
                        </Link>
                        <div className="content">
                            <h2>درباره نکویاد</h2>
                            <div className="text">
                                نکویار سامانه هدفمند جهت ایجاد خدمات آنلاین در زمینه‌، برگزاری
                                مجالس ترحیم برخط و برگزاری دوره های ختم صلوات قرآن و... و نیز دید
                                بانی جهت تامین مایحتاج نیازمندان و محرومین می‌باشد تامین لوازم
                                التحریر، سبد غذایی، تهیه پوشاک، ماسک و مواد بهداشتی تامین هزینه
                                ویزیت درمان، خرید جهیزیه، اجاره منزل، حمایت از خانواده زندانیان
                                جرایم غیر عمد و امور اشتغال زایی و کارآفرینی از گزینه های مدنظر
                                نکویاد جهت کمکهای نقدی می باشد
                            </div>
                            <Link to="" title="بیشتر" className="about-more">
                                بیشتر
                                <span>
                  <svg
                      version="1.1"
                      width="30px"
                      height="30px"
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      width="16px"
                      height="12px"
                      viewBox="0 0 123.725 123.725"
                      style={{enableBackground: "new 0 0 123.725 123.725"}}
                      xmlSpace="preserve"
                  >
                    <g>
                      <path
                          d="M2.325,67.002l38.6,30c3.9,3.101,9.7,0.3,9.7-4.7V81.902c0-3.3,2.6-5.9,5.899-5.9h61.5c3.301,0,5.7-2.8,5.7-6.1v-16.1 c0-3.3-2.399-5.8-5.7-5.8h-61.5c-3.3,0-5.899-2.9-5.899-6.2v-10.3c0-5-5.8-7.9-9.8-4.8l-38.5,30.8 C-0.775,59.902-0.775,64.603,2.325,67.002z"/>
                        {" "}
                    </g>
                      {" "}
                      <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>
                      {" "}
                      <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>
                      {" "}
                      <g> </g>
                      {" "}
                  </svg>
                </span>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="pagewrapper" id="home-brands">
                    <div className="container">
                        <h2 className="title">همکاران و خیرین</h2>
                        <div className="content">
                            <div className="brands-item">
                                <Link to="" title="">
                                    <img src={gallery1} alt="" width="" height=""/>
                                </Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title="">
                                    <img src={gallery2} alt="" width="" height=""/>
                                </Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title="">
                                    <img src={gallery3} alt="" width="" height=""/>
                                </Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title="">
                                    <img src={gallery4} alt="" width="" height=""/>
                                </Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title="">
                                    <img src={gallery5} alt="" width="" height=""/>
                                </Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title="">
                                    <img src={gallery6} alt="" width="" height=""/>
                                </Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title="">
                                    <img src={gallery7} alt="" width="" height=""/>
                                </Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title="">
                                    <img src={gallery8} alt="" width="" height=""/>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pagewrapper" id="home-middle-banner">
                    <div className="container">
                        <Link to="" title="">
                            <img src={Goorbagheh} alt="" width="1368" height="140"/>
                        </Link>
                    </div>
                </div>

                <div className="pagewrapper" id="galleries">
                    <div className="container">
                        <h2 className="title">گالری تصاویر</h2>
                        <div className="content">
                            <Link to="" title="" className="gallery-item">
                                <img src={gallery1} alt="" width="" height=""/>
                            </Link>
                            <Link to="" title="" className="gallery-item">
                                <img src={gallery2} alt="" width="" height=""/>
                            </Link>
                            <Link to="" title="" className="gallery-item">
                                <img src={gallery3} alt="" width="" height=""/>
                            </Link>
                            <Link to="" title="" className="gallery-item">
                                <img src={gallery4} alt="" width="" height=""/>
                            </Link>
                            <Link to="" title="" className="gallery-item">
                                <img src={gallery5} alt="" width="" height=""/>
                            </Link>
                            <Link to="" title="" className="gallery-item">
                                <img src={gallery6} alt="" width="" height=""/>
                            </Link>
                            <Link to="" title="" className="gallery-item">
                                <img src={gallery7} alt="" width="" height=""/>
                            </Link>
                            <Link to="" title="" className="gallery-item">
                                <img src={gallery8} alt="" width="" height=""/>
                            </Link>
                        </div>
                        <Link to="" title="مشاهده همه" className="gallery-more">
                            مشاهده همه
                            <span>
                <svg
                    version="1.1"
                    width="30px"
                    height="30px"
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="16px"
                    height="12px"
                    viewBox="0 0 123.725 123.725"
                    style={{enableBackground: "new 0 0 123.725 123.725"}}
                    xmlSpace="preserve"
                >
                  {" "}
                    <g>
                    {" "}
                        <path
                            d="M2.325,67.002l38.6,30c3.9,3.101,9.7,0.3,9.7-4.7V81.902c0-3.3,2.6-5.9,5.899-5.9h61.5c3.301,0,5.7-2.8,5.7-6.1v-16.1 c0-3.3-2.399-5.8-5.7-5.8h-61.5c-3.3,0-5.899-2.9-5.899-6.2v-10.3c0-5-5.8-7.9-9.8-4.8l-38.5,30.8 C-0.775,59.902-0.775,64.603,2.325,67.002z"/>
                        {" "}
                  </g>
                    {" "}
                    <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>
                    {" "}
                    <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>
                    {" "}
                    <g> </g>
                    {" "}
                </svg>
              </span>
                        </Link>
                    </div>
                </div>

                <div className="clear"></div>
                <Footer/>
            </div>}
        </>
    );
};

export default Home;
